import { assert } from '../../../../util/assert';
import { QueryExpressionSegment, QueryRangeSegment } from '../../../../../api';
import { PluginSlugs } from '../../../../../config';
import { ViewPartitionKeyBySlug } from '../../../../../config/view';
import { isAbsolutePeriod } from '../../../../../domain';
import { LineVisualization } from '../../../../domain/visualization';
import { castRankingToCohortState, getPartition, View } from '../../../../domain';
import { QueryableQueryRequest } from '../../../../app';

export function buildLineRequest(
    view: View,
    visualization: LineVisualization
): QueryableQueryRequest {
    const partition = getPartition(view);
    // assert(facet, 'facet key is required for distribution query');
    assert(partition, 'no partition found on view');
    const [metric] = visualization.metrics;
    const partitionKey =
        // HACK we need to use the "source" of the partition property but that is not
        // currently modelled
        ViewPartitionKeyBySlug[metric.view] ?? partition.key;

    const period = visualization.period ?? { amount: 4, interval: 'week' };

    const cohortstate = castRankingToCohortState(visualization.ranking);

    return {
        projections: [
            {
                name: 'main',
                columns: [
                    {
                        key: metric.key,
                    },
                ],
            },
        ],
        filters: [
            isAbsolutePeriod(period)
                ? {
                      key: partitionKey,
                      operator: 'between',
                      value: {
                          from: period.start,
                          to: period.end,
                      },
                  }
                : {
                      key: partitionKey,
                      operator: 'previous',
                      value: period,
                  },
            ...visualization.filters,
        ],
        timeseries: {},
        granularity: visualization.granularity,
        source: { view: view.source },
        comparison: null,
        segment: [],
        segments: [
            {
                kind: 'asset',
                name: 'My company',
            },
            ...(cohortstate.mode === 'fixed'
                ? cohortstate.config.fixed.cohorts
                      .filter((item) => item.visible)
                      .map((item): QueryRangeSegment => {
                          return {
                              kind: 'range',
                              name: item.name,
                              range: {
                                  column: cohortstate.config.fixed.comparison!,
                                  start: {
                                      kind: 'percentile',
                                      value: item.lower,
                                  },
                                  end: {
                                      kind: 'percentile',
                                      value: item.upper,
                                  },
                              },
                              reducer: {
                                  kind: 'percentile',
                                  value: 50,
                              },
                          };
                      })
                : cohortstate.config.dynamic.cohorts
                      .filter((item) => item.visible)
                      .map(
                          (item): QueryExpressionSegment => ({
                              kind: 'expression',
                              name: item.name,
                              expr: { kind: 'boolean', value: true },
                              reducer: {
                                  kind: 'percentile',
                                  value: item.value,
                              },
                          })
                      )),
        ],
    };
}
